<template>
	<w-dialog
		:model-value="showDialog"
		:title="type == 'new' ? 'Add Qari' : 'Edit Qari'"
		title-class="bg-main white"
		transition="slide-down"
		persistent="persistent"
		:fullscreen="false"
		:persistent-no-animation="false"
		:width="500"
		style="position:fixed;"
	>
		<w-alert error plain v-if="dialogError"
			><p>
				Fail To {{ type == 'new' ? 'Add' : 'Change' }} Qari
			</p></w-alert
		>
		<w-alert success plain v-if="dialogSuccess"
			><p>
				Qari {{ type == 'new' ? 'Added' : 'Changed' }} Successful !!!
			</p></w-alert
		>
		<w-form
			action="#"
			method="post"
			@submit.prevent="addQari()"
			class="mt2"
		>
			<w-input
				outline="outline"
				placeholder="Qari Name"
				color="text-main"
				inner-icon-left="mdi mdi-account"
				v-model="name"
				:validators="[validators.required]"
			/>
			<w-input
				outline="outline"
				Placeholder="Qari Country"
				color="text-main"
				class="mt4"
				inner-icon-left="mdi mdi-file"
				v-model="country"
				:validators="[validators.required]"
			/>
			

			<w-flex class="mt6 text-center">
				<w-button class="" @click="$emit('closed')" bg-color="error"
					>Close</w-button
				>
				<w-button
					v-if="type == 'new'"
					type="submit"
					class="ml5 bg-main"
					bg-color="teal"
					color="white"
					:loading="isLoading"
					>SAVE</w-button
				>
				<w-button
					v-if="type == 'edit'"
					type="submit"
					class="ml5 bg-main"
					bg-color="teal"
					color="white"
					:loading="isLoading"
					>UPDATE</w-button
				>
			</w-flex>
		</w-form>
	</w-dialog>
</template>
<script>
import axios from 'axios';
export default {
	props: {
		showDialog: {
			type: Boolean,
			required: true,
			validators: function(value) {
				return value === true || value === false;
			},
		},
		content: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			type: 'new',
			id: null,
			name: '',
			country: '',
			isLoading: false,
			validators: {
				required: (value) => !!value || 'This field is required',
			},
			dialogError: false,
			dialogSuccess: false,
		};
	},
	methods: {
		addQari() {
			if (
				this.name != '' &&
				this.country != ''
			) {
				this.isLoading = true;
				let formData = new FormData();
				formData.append(
					'status',
					this.type == 'new' ? 0 : 1
				);
				formData.append('qariId', this.id??0);
				formData.append('qariName', this.name);
				formData.append('country', this.country);
				axios
					.post('qari.php', formData)
					.then((data) => {
						this.isLoading = false;
						let result = data.data;
						if (result.status == 200) {
							this.$emit('load-data', data.data);
							this.dialogError = false;
							this.dialogSuccess = true;
						} else {
							this.dialogError = true;
							this.dialogSuccess = false;
						}
					})
					.catch((error) => {
						this.isLoading = false;
						alert(error);
					});
			}
		},
	},
	watch: {
		showDialog() {
			this.dialogSuccess = false;
			this.dialogError = false;
			let qari = this.content;
			this.id = qari.id;
			this.type = qari.type;
			this.name = qari.name
			this.country = qari.country
		},
	}
};
</script>
<style scoped></style>
